// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function Chip$Chip(props) {
  let children = props.children;
  let __className = props.className;
  let onClick = props.onClick;
  let __active = props.active;
  let active = __active !== undefined ? __active : false;
  let className = __className !== undefined ? __className : "";
  let chipStyles = Emotion.Css.css({
    display: "inline-flex",
    alignItems: "center",
    gap: "0.25rem",
    padding: "0.25rem 0.5rem",
    borderRadius: Emotion.Utils.Border.getRadius("sm"),
    border: `1px solid ` + Emotion.Utils.Color.border,
    backgroundColor: active ? Emotion.Utils.Color.bgElevated : Emotion.Utils.Color.bgSecondary,
    color: active ? Emotion.Utils.Color.textPrimary : Emotion.Utils.Color.textSecondary,
    fontFamily: Theme.Theme.Typography.fontFamily.sans,
    fontSize: "0.75rem",
    fontWeight: "500",
    lineHeight: "1.4",
    cursor: Stdlib_Option.isSome(onClick) ? "pointer" : "default",
    transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out",
    ":hover": {
      color: Emotion.Utils.Color.textPrimary,
      backgroundColor: Emotion.Utils.Color.bgElevated
    }
  });
  if (onClick !== undefined) {
    return JsxRuntime.jsx("button", {
      children: children,
      className: Emotion.Css.cx([
        chipStyles,
        className
      ]),
      type: "button",
      onClick: onClick
    });
  } else {
    return JsxRuntime.jsx("span", {
      children: children,
      className: Emotion.Css.cx([
        chipStyles,
        className
      ])
    });
  }
}

let Chip = {
  make: Chip$Chip
};

export {
  Chip,
}
/* Theme Not a pure module */
